<!--
� 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
-->

<section class="regional-emissions-section">
	<form
		class="date-filter"
		[formGroup]="timePeriodForm"
	>
		<globalictcc-datepicker
			label="Time period"
			formControlName="timePeriod"
		/>

		<globalictcc-button
			label="Apply"
			(handleClick)="fetchCharts()"
			[disabled]="timePeriodForm.invalid"
		/>
	</form>

	@let canSeeAverageCarbonIntensity =
		authorizationService.canSee(grants.averageCarbonIntensityByRegion);
	@let canSeeCarbonIntensityByCountry =
		authorizationService.canSee(grants.carbonIntensityByCountry);

	<div class="charts">
		@if (canSeeAverageCarbonIntensity) {
			@let averageCarbonIntensity = averageCarbonIntensityByRegion$ | async;
			<div class="chart-container">
				<globalictcc-chart
					chartType="barX"
					[data]="averageCarbonIntensity?.data?.chart"
					[isLoading]="averageCarbonIntensity?.isLoading ?? true"
					[hasError]="
						averageCarbonIntensity?.hasError || averageCarbonIntensity?.data?.hasError
					"
					[isLegendVisible]="true"
					[configOverrides]="barOverrides"
					[patterns]="barPatterns"
					[colors]="barColors"
					tooltipLabel="region"
					(handleChartRefresh)="onApplyForRegionalEmissions()"
				/>
			</div>
		}

		@if (canSeeCarbonIntensityByCountry) {
			@let carbonIntensity = carbonIntensityByCountry$ | async;
			@let carbonIntensityHasError =
				!!(carbonIntensity?.hasError || carbonIntensity?.data?.hasError);
			<div class="highlighted-chart">
				<span class="chart-title">{{ carbonIntensity?.data?.chart?.title }}</span>

				<form
					class="country-filter"
					[formGroup]="regionForm"
				>
					<globalictcc-dropdown
						label="Choose country"
						[options]="countryOptions"
						formControlName="region"
					/>

					<globalictcc-button
						label="Apply"
						[disabled]="
							!regionForm.valid ||
							!carbonIntensity?.data?.chart?.lineSeries?.length ||
							carbonIntensityHasError
						"
						(handleClick)="onApplyForEmissionsByRegion()"
					/>
				</form>

				<globalictcc-chart
					chartType="line"
					[data]="carbonIntensity?.data?.chart"
					[isLoading]="carbonIntensity?.isLoading ?? true"
					[hasError]="carbonIntensityHasError"
					[isTitleVisible]="false"
					[configOverrides]="lineOverrides"
					(handleChartRefresh)="onApplyForEmissionsByRegion()"
				/>
			</div>
		}

		<globalictcc-map
			[isTitleVisible]="false"
			[data]="regionsMapChart?.chart"
			[isLoading]="isRegionsMapChartLoading"
			[hasError]="regionsMapChart?.hasError"
			[configOverrides]="regionsMapChartOverrides"
			(handleMapRefresh)="onMapRefresh()"
		/>
	</div>
</section>
